import React from "react";
import useNotificationBanner from "../../hooks/useNotificationBanner";

const BANNER_STYLES = {
	warning: { bg: "#FFEE8C", color: "#000000", icon: "⚠️" },
	info: { bg: "#FFEE8C", color: "#000000", icon: "ℹ️" },
	error: { bg: "#FFEE8C", color: "#000000", icon: "🚨" },
};

/**
 * Drop-in notification banner — renders nothing when disabled.
 *
 * variant="bar"  → full-width bar below the fixed header (used in Header.js)
 * variant="css"  → uses .header-data-warning CSS classes (legacy inner-page headers)
 *
 * currentPage    → page slug string (e.g. "landing", "vff"). When omitted the
 *                  banner always shows (backwards-compatible). When provided the
 *                  banner only shows if banner.pages is empty (= all pages) or
 *                  includes this slug.
 */
const NotificationBanner = ({ variant = "css", currentPage }) => {
	const { banner } = useNotificationBanner();

	if (!banner.enabled || !banner.message) return null;

	// Page-targeting filter: empty pages array means "show everywhere"
	if (
		currentPage &&
		banner.pages.length > 0 &&
		!banner.pages.includes(currentPage)
	) {
		return null;
	}

	const style = BANNER_STYLES[banner.type] || BANNER_STYLES.warning;

	if (variant === "bar") {
		return (
			<div
				style={{
					width: "100%",
					backgroundColor: style.bg,
					borderBottom: `2px solid ${style.border}`,
					padding: "6px 10px",
					fontSize: "0.82rem",
					color: style.color,
					display: "flex",
					alignItems: "center",
					gap: "8px",
					fontFamily: "MAN EUROPE_Bold, sans-serif",
					boxSizing: "border-box",
				}}
			>
				<span style={{ flexShrink: 0 }}>{style.icon}</span>
				<span>{banner.message}</span>
			</div>
		);
	}

	// CSS class variant — used by legacy inner-page headers
	return (
		<div
			className="header-data-warning"
			style={{ backgroundColor: style.bg, borderColor: style.border }}
		>
			<span className="header-data-warning-icon">{style.icon}</span>
			<span className="header-data-warning-text" style={{ color: style.color }}>
				{banner.message}
			</span>
		</div>
	);
};

export default NotificationBanner;
